import React, {useState} from 'react';
import {Modal} from "antd";
import PropTypes from 'prop-types';
import {useTranslation} from "react-i18next";
import deleteImg from "../../../asset/icon/delete.png";

const DG_Menu_Delete = props => {

    const id = props?.id

    const {t} = useTranslation()
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
        props.onOk(id)

    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <img src={deleteImg}
                 className={"cursor-pointer"}
                 title={"Xóa"}
                 onClick={showModal}
                 alt={deleteImg}/>
            <Modal
                visible={isModalVisible}
                onCancel={handleCancel}
                okText={t("common.btn.delete")}
                cancelText={<strong style={{color: "rgba(236,41,41,0.9)"}}>{t("common.btn.cancel")}</strong>}
                destroyOnClose={true}
                {...props}
                onOk={handleOk}
            >
                <p>{props.content ? props.content : t("common.message.deleteAsk")}</p>
            </Modal>
        </>
    );
};

DG_Menu_Delete.propTypes = {
    onOk: PropTypes.func.isRequired,

};

export default DG_Menu_Delete;
